const faqAccordion = () => {
  const items = document.querySelectorAll('.js-faq-item')
  if (items.length == 0) {
    return
  }
  items.forEach((item) => {
    item.addEventListener('click', () => {
      items.forEach((it) => {
        if (it != item) {
          it.classList.remove('active')
        }
      })
      item.classList.toggle('active')
    })
  })
}

export default faqAccordion
